import axios from 'axios';
export class LoginCommand {
    constructor() {
        this.URI = 'https://mycast.xyz:3001/auth';
    }
    async execute(id, password) {
        const query = `mcid=${id}&mcpw=${password}`;
        const { data } = await axios.post(this.URI, query);
        return data;
    }
}
